import React from "react";
import GameInstructionModal from "./GameInstructionModal";

const ModalRapidMovement = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Rapid Movement"
      gamePath="/userDashboard/game/rapid-movement"
      icon="solar:bolt-bold"
      instructions={[
        "Patch your better eye.",
        "Rapidly press the corresponding letter on your keyboard that matches the flashing letter on the screen."
      ]}
      isBinocular={false}
    />
  );
};

export default ModalRapidMovement;
